// extracted by mini-css-extract-plugin
export default {"sub-disclaimer":"hezMd7","subDisclaimer":"hezMd7","guarantee":"s_VanW","icon-wrapper":"nFRFbz","iconWrapper":"nFRFbz","money-back":"MisQMR","moneyBack":"MisQMR"};